"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const external_frame_1 = require("@clearsummit/external-frame");
exports.default = external_frame_1.Banner;
